// resources/supportTickets.js
import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  NumberField,
  ImageField,
  DateField,
  SelectField,
  EditButton,
  ShowButton,

  Filter,
  TextInput,
  SelectInput,
  ReferenceInput,
  AutocompleteInput,
  ReferenceField,

  Create,
  SimpleForm,
  NumberInput,
  ImageInput,

  Edit,

  Show,
  SimpleShowLayout,
} from 'react-admin';

const subjectChoices = [
  { id: 'Deposit', name: 'Deposit Not Received' },
  { id: 'Withdrawal', name: 'Withdrawal Problem' },
  { id: 'Account', name: 'Account & Profile' },
  { id: 'Other', name: 'Other Issues' },
];

const statusChoices = [
  { id: 'Pending', name: 'Pending' },
  { id: 'Solved', name: 'Solved' },
];

// ---------------- FILTER (List এর উপরে সার্চ/ফিল্টার বার) ----------------
// ↓ পরিবর্তন: আগে <TextInput source="user" /> দিয়ে সরাসরি username টেক্সট সার্চ
// করার চেষ্টা হয়েছিল, কিন্তু backend এ "user" ফিল্ড আসলে user এর ID (ForeignKey),
// username স্ট্রিং না — তাই ওই ফিল্টার কাজ করছিল না। এখন ReferenceInput +
// AutocompleteInput দিয়ে username লিখে ইউজার খুঁজে সিলেক্ট করা যাবে, আর এটা
// আসলে user id দিয়েই ফিল্টার করবে যেটা backend বুঝবে।
const SupportTicketFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput
      source="user"
      reference="users"
      label="Username"
      alwaysOn
      filterToQuery={(searchText) => ({ username: searchText })}
    >
      <AutocompleteInput optionText="username" />
    </ReferenceInput>

    <SelectInput source="subject" label="Subject" choices={subjectChoices} alwaysOn />
    <SelectInput source="status" label="Status" choices={statusChoices} alwaysOn />

    <TextInput source="order_number" label="Order number" />
    <TextInput source="trx_id" label="Transaction id" />
    <TextInput source="wallet_number" label="Wallet number" />
  </Filter>
);

// ---------------- LIST ----------------
export const SupportTicketList = (props) => (
  <List {...props} filters={<SupportTicketFilter />} sort={{ field: 'created_at', order: 'DESC' }}>
    <Datagrid rowClick="show">
      <TextField source="id" label="Id" />

      {/* ↓ পরিবর্তন: আগে <TextField source="user.username" /> ব্যবহার হচ্ছিল, যেটা
          API রেসপন্সে user অবজেক্ট নেস্টেড না থাকলে ফাঁকা দেখাতো। এখন
          ReferenceField দিয়ে users resource থেকে username টেনে আনা হচ্ছে, আর
          এতে ক্লিক করলে সরাসরি সেই ইউজারের Show/Overview পেজ ওপেন হবে। */}
      <ReferenceField source="user" reference="users" label="Username" link="show">
        <TextField source="username" />
      </ReferenceField>

      <SelectField source="subject" label="Subject" choices={subjectChoices} />
      <TextField source="trx_id" label="Trx" />
      <TextField source="order_number" label="Order number" />
      <NumberField source="order_amount" label="Order amount" />
      <NumberField source="withdrawal_amount" label="Withdrawal amount" />
      <TextField source="wallet_number" label="Wallet number" />
      <SelectField source="status" label="Status" choices={statusChoices} />
      <DateField source="created_at" label="Created at" showTime />
      <ShowButton />
      <EditButton />
    </Datagrid>
  </List>
);

// ---------------- CREATE ----------------
export const SupportTicketCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <SelectInput source="subject" label="Subject" choices={subjectChoices} isRequired />
      <TextInput source="message" label="Message" multiline fullWidth />

      <TextInput source="trx_id" label="Transaction id" />
      <TextInput source="order_number" label="Order number" />
      <NumberInput source="order_amount" label="Order amount" />
      <ImageInput source="deposit_proof" label="Deposit proof" accept="image/*">
        <ImageField source="src" title="title" />
      </ImageInput>

      <NumberInput source="withdrawal_amount" label="Withdrawal amount" />
      <TextInput source="wallet_number" label="Wallet number" />

      <SelectInput source="status" label="Status" choices={statusChoices} defaultValue="Pending" />
    </SimpleForm>
  </Create>
);

// ---------------- EDIT ----------------
export const SupportTicketEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextField source="id" label="Id" />

      <ReferenceField source="user" reference="users" label="Username" link="show">
        <TextField source="username" />
      </ReferenceField>

      <SelectInput source="subject" label="Subject" choices={subjectChoices} />
      <TextInput source="message" label="Message" multiline fullWidth />

      <TextInput source="trx_id" label="Transaction id" />
      <TextInput source="order_number" label="Order number" />
      <NumberInput source="order_amount" label="Order amount" />

      {/* শুধু প্রিভিউ — আপলোড অপশন নেই */}
      <ImageField source="deposit_proof" label="Deposit proof" />

      <NumberInput source="withdrawal_amount" label="Withdrawal amount" />
      <TextInput source="wallet_number" label="Wallet number" />

      <SelectInput source="status" label="Status" choices={statusChoices} />
      <DateField source="created_at" label="Created at" showTime />
    </SimpleForm>
  </Edit>
);

// ---------------- SHOW ----------------
export const SupportTicketShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" label="Id" />

      <ReferenceField source="user" reference="users" label="Username" link="show">
        <TextField source="username" />
      </ReferenceField>

      <SelectField source="subject" label="Subject" choices={subjectChoices} />
      <TextField source="message" label="Message" />

      <TextField source="trx_id" label="Transaction id" />
      <TextField source="order_number" label="Order number" />
      <NumberField source="order_amount" label="Order amount" />
      <ImageField source="deposit_proof" label="Deposit proof" />

      <NumberField source="withdrawal_amount" label="Withdrawal amount" />
      <TextField source="wallet_number" label="Wallet number" />

      <SelectField source="status" label="Status" choices={statusChoices} />
      <DateField source="created_at" label="Created at" showTime />
    </SimpleShowLayout>
  </Show>
);